import React, { useCallback, useEffect } from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { hoverTips } from "utils/mixin";

const StyledModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.maskColor};
  z-index: 1000;

  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledContainer = styled.div`
  padding: 30px 60px 20px 60px;
  background-color: ${({ theme }) => theme.white};
  border-radius: 5px;
  box-shadow: ${({ theme }) => theme.boxShadow};
  /* outline: none; */

  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 1001;
`;

const StyledCloseButton = styled.div`
  display: block;
  padding: 2px 5px;
  cursor: pointer;
  color: ${({ theme }) => theme.black};
  opacity: 0.7;

  ${({ theme, tips }) => hoverTips(theme, tips)};

  :hover {
    color: ${({ theme }) => theme.dark};
    opacity: 1;
  }

  position: absolute;
  top: 10px;
  right: 10px;
`;

const Modal = ({ visible, onClose, children, clickMaskWillClose = false }) => {
  useEffect(() => {
    if (visible) {
      document.querySelector("body").setAttribute("style", "overflow : hidden");
    } else {
      document.querySelector("body").removeAttribute("style");
    }
  }, [visible]);

  const handleClickMask = useCallback(() => {
    if (clickMaskWillClose) {
      onClose && onClose();
    }
  }, [clickMaskWillClose, onClose]);

  const modal = (
    <StyledModal onClick={handleClickMask}>
      <StyledContainer
        // draggable="true"
        onClick={(e) => {
          //阻止事件进一步传播
          e.stopPropagation();
        }}
      >
        <StyledCloseButton tips="关闭" onClick={onClose}>
          <FontAwesomeIcon icon={faTimes} />
        </StyledCloseButton>
        {children}
      </StyledContainer>
    </StyledModal>
  );

  if (visible) {
    document.querySelector("body").setAttribute("style", "overflow : hidden");
    return ReactDOM.createPortal(modal, document.querySelector("body"));
  } else {
    document.querySelector("body").removeAttribute("style");
    return null;
  }
};

export default Modal;
